// removed by extract-text-webpack-plugin
module.exports = {"btn-apex-primary":"_1c5JokPi0gjQqX_IzCHChe","focus":"_1DnVjKiFR3O5-ceIaSD8CJ","active":"_3ZcVdXQFB5HUCsa2sQgw4G","disabled":"N-sfQm_Lcy8CXbK9Z2w4P","badge":"_3HqwN2dSx-taKQdrrtil5s","btn-apex-secondary":"_1WMIr5Vs5mtHpODlDdF04U","btn-apex-secondary-no-hover":"_2vUQogdYbl4BnFGo__ZbW8","btn-apex-negative":"_2Ati22sejYf3yMPn5taxo0","btn-apex-orange":"PDauraTFnacPmddUTRFUJ","title":"_2bkaZ_9BdnYCyfTbFXaHIA","badgeColor":"_3cC-luipM8XoYKsEDsGePl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DetailsPanel/styles.css
// module id = 3138
// module chunks = 0